var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-detail"},[_c('aside',{staticClass:"aside-resume"},[_c('aside-menu')],1),_c('div',{staticClass:"scrollY"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }